import { createRouter, createWebHistory } from 'vue-router';
import { useAuth } from '../stores/auth';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/login', component: () => import('../views/LoginView.vue'), meta: { public: true } },
    {
      path: '/',
      component: () => import('../views/AppShell.vue'),
      children: [
        { path: '', redirect: '/tenants' },
        { path: 'tenants', component: () => import('../views/TenantsView.vue') },
        { path: 'metrics', component: () => import('../views/MetricsView.vue') },
        { path: 'diagnostics', component: () => import('../views/DiagnosticsView.vue') },
        { path: 'backups', component: () => import('../views/BackupsView.vue') },
        { path: 'defaults', component: () => import('../views/DefaultsView.vue') },
        { path: 'invoice-settings', component: () => import('../views/BillingSettingsView.vue') },
      ],
    },
  ],
});

// Guard: усе крім /login потребує auth.
router.beforeEach(async (to) => {
  const auth = useAuth();
  if (!auth.ready) await auth.hydrate();
  if (!to.meta.public && !auth.isAuthenticated) {
    return { path: '/login', query: { next: to.fullPath } };
  }
  if (to.path === '/login' && auth.isAuthenticated) {
    return { path: '/tenants' };
  }
});

export default router;
